import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import ContentSettingsCard from "DreamCast/Shared/ContentSettingsCard";
import {
  buildTagOptionsByTypeCode,
  extractSettingsTagDefinitions,
} from "DreamCast/Shared/ContentSettingsCard/tagSchema";
import { fetchDreamcastContentSettingsConfig } from "DreamCast/api/media";

const OPTION_KEYS_BY_TYPE = {
  LOCATION: "locationOptions",
  LANGUAGE: "languageOptions",
  OCCUPATION: "occupationOptions",
  KEYWORD_TAG: "keywordOptions",
  HIDDEN_TAG: "hiddenTagOptions",
};

export function DisclosureContentSettings({ tags, onChange }) {
  const [tagDefinitions, setTagDefinitions] = useState([]);

  useEffect(() => {
    let subscribed = true;

    fetchDreamcastContentSettingsConfig()
      .then((response) => {
        const config = response?.data || response;
        if (!subscribed || !config) return;
        setTagDefinitions(extractSettingsTagDefinitions(config));
      })
      .catch(() => {
        if (subscribed) setTagDefinitions([]);
      });

    return () => {
      subscribed = false;
    };
  }, []);

  const optionsByType = buildTagOptionsByTypeCode(tagDefinitions);
  const resolvedTags = tagDefinitions.reduce(
    (current, definition) => {
      const typeCode = definition.attributeTypeCode;
      const optionKey = OPTION_KEYS_BY_TYPE[typeCode];
      return optionKey
        ? { ...current, [optionKey]: optionsByType[typeCode] || [] }
        : current;
    },
    { ...tags, tagDefinitions },
  );

  return (
    <ContentSettingsCard
      tagsOnly
      tags={resolvedTags}
      onChange={(nextSettings) => onChange(nextSettings.tags || resolvedTags)}
    />
  );
}

DisclosureContentSettings.propTypes = {
  tags: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

DisclosureContentSettings.defaultProps = {
  tags: {},
};

export default DisclosureContentSettings;
